import { createMuiTheme } from "@material-ui/core/styles"

const defaultTheme = createMuiTheme({
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      "Nunito Sans",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  palette: {
    primary: {
      main: "#439A97",
      light: "#62B6B7",
      dark: "#62B6B7",
    },
    sectionTitle: {
      main: "#0449b0",
      light: "#62B6B7",
      dark: "#62B6B7",
    },
  },
  formSectionTitle: {
    color: "#0449b0",
    marginTop: "1rem",
  },
})

export default defaultTheme
